<template>
  <div>
    <base-header class="mt-4 pb-6" type=""></base-header>
      <b-container fluid class="mt--6">
        <div>
          <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
        </div>
        <b-row>
          <b-col lg="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col cols="8">
                        <h3>{{language_terms['BULK_POSTING']}}</h3>
                    </b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col md="3" >
                    <base-input :label="language_terms['DATE_FROM']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="filter.date_from">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col md="3">
                    <base-input :label="language_terms['DATE_TO']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="filter.date_to">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col md="3">
                    <base-input :label="language_terms['DOCUMENT_TYPE']">
                      <el-select v-model="filter.document_type" filterable>
                        <el-option v-for="doctype in document_types_option"
                                  :key="doctype.value"
                                  :label="doctype.label"
                                  :value="doctype.value">
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>
                  <b-col md="2">
                    <base-input :label="language_terms['STATUS']">
                      <el-select v-model="filter.statu" filterable @change="onChange">
                        <el-option v-for="option in status_option"
                                  :key="option.value"
                                  :label="option.label"
                                  :value="option.value">
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>
                  <b-col cols="1" class="mt-4">
                    <base-button type="primary" @click="onClickSearch()" class="mt-2"><i class="fa fa-search"></i></base-button>
                  </b-col>
                </b-row>
              </card>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="docs.length > 0">
          <b-col lg="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col lg="11">
                        <h3>Posted List</h3>
                    </b-col>
                    <b-col lg="2" class="ml-4 && mt-4">
                      <input class="Checkbox" type="checkbox" value="1" v-model="is_selected" switch @change="selectAll($event)">
                    </b-col>
                  </b-row>
                </div>
                <b-row class="mt--4">
                  <b-col cols="12" class="mt-3">
                      <b-table-simple hover responsive>
                          <b-thead head-variant="light">
                              <b-th>{{language_terms['SELECT']}}</b-th>
                              <b-th>{{language_terms['DATE']}}</b-th>
                              <b-th>{{language_terms['TYPE']}}</b-th>
                              <b-th>{{language_terms['DOC_#']}} </b-th>
                              <b-th>{{language_terms['CUSTOMER'] +' / '+ language_terms['VENDOR']}} </b-th>
                              <b-th>{{language_terms['CURRENCY']}} </b-th>
                              <b-th>{{language_terms['AMOUNT']}}</b-th>
                              <b-th>{{language_terms['EX_RATE']}}</b-th>
                              <b-th>{{language_terms['IN_HOME_AMOUNT']}}</b-th>
                          </b-thead>
                          <b-tbody>
                              <tr v-for="(invoice, i) in docs" :key="i">
                                  <td>
                                    <input class="Checkbox" type="checkbox" value="1" v-model="invoice.is_selected" switch @change= "updateSelectedCount(invoice.is_selected)">
                                  </td>
                                  <td>{{invoice.date}}</td>
                                  <td>{{invoice.type}}</td>
                                  <td>{{invoice.document_code}}</td>
                                  <td>{{invoice.contact_name}}</td>
                                  <td>{{invoice.currency_code}}</td>
                                  <td>{{invoice.amount}}</td>
                                  <td>{{invoice.currency_exchange_rate}}</td>
                                  <td>{{invoice.amount_home}}</td>
                              </tr>
                          </b-tbody>
                      </b-table-simple>
                      <b-row v-if="filter.statu == '0' && selectedCount > 0" class="mt-3">
                          <div class="floating-bar">
                            <div class="floating-bar-container" align="center">
                                <b-button-group>
                                    <b-button class="transparent-btn"   @click="onClickPost()">
                                        <i class="fas fa-save mr-2 text-info"></i>{{language_terms['POST']}}
                                    </b-button>
                                </b-button-group>
                            </div>
                        </div>
                      </b-row>
                      <b-row v-else-if="selectedCount > 0" class="mt-3">
                          <div class="floating-bar">
                            <div class="floating-bar-container" align="center">
                                <b-button-group>
                                    <b-button class="transparent-btn"   @click="onClickUnpost()">
                                        <i class="fas fa-save mr-2 text-info"></i>{{language_terms['UNPOST']}}
                                    </b-button>
                                </b-button-group>
                            </div>
                        </div>
                      </b-row>
                  </b-col>
                </b-row>
              </card>
            </div>
          </b-col>
        </b-row>
      </b-container>
  </div>
</template>
<style>
th.VueTables__sortable {color:rgb(255,255,255);}
td.VueTables__row  {color:black}
.v-data-table /deep/ .sticky-header {position: sticky; top: var(--toolbarHeight);}
.v-data-table /deep/ .v-data-table__wrapper {overflow: unset;}
</style>
<style>
input.Checkbox {width: 25px; height: 25px;}</style>
<script>
import moment from 'moment'
import { Select, Option, Checkbox } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import Vue from 'vue'

export default {
  components:{
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
  computed:{
      ...mapState({
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
    }),
  },
  async mounted()
  {
    this.loadingCounter++
    this.filter.date_to = new Date()
    this.filter.date_to.setDate(0);
    this.loadingCounter--
  },

  data(){
    return{
      selectedCount: 0,
      is_selected: 1,
      selectedInvoice:[],
      loadingCounter:0,
      filter:{
        document_type:'SALES INVOICE',
        statu:'0',
        date_from:null,
        date_to:null,
      },
      docs:[],
      document_types_option:[
        {
          label:"Sales Invoices",
          value:'SALES INVOICE'
        },
        {
          label:"Purchase Invoices",
          value:"PURCHASE INVOICE"
        },
        {
          label:"Sales Receipts",
          value:"SALES RECEIPT"
        },
        {
          label:"Purchase Receipts",
          value:"PURCHASE RECEIPT"
        },
        {
          label:"AR Credit Notes",
          value:"SALES CREDIT NOTE"
        },
        {
          label:"AR Debit Notes",
          value:"SALES DEBIT NOTE"
        },
        {
          label:"AP Credit Notes",
          value:"PURCHASE CREDIT NOTE"
        },
        {
          label:"AP Debit Notes",
          value:"PURCHASE DEBIT NOTE"
        },
        // {
        //   label:"Credit Notes",
        //   value:"CN"
        // },
        // {
        //   label:"Debit Notes",
        //   value:"DN"
        // }
      ],
      status_option:[
        {
          label:"Unposted",
          value:'0'
        },
        {
          label:"Posted",
          value:"1"
        }
      ],
    }
  },

  methods:{
    async onChange()
    {
      this.docs = []
    },
    async updateSelectedCount(is_checked)
    {
      if (is_checked)
        this.selectedCount++
      else
        this.selectedCount--
    },
    async selectAll()
    {
      this.selectedCount = 0
      for (let x = 0;x < this.docs.length;x++)
      {
        this.docs[x].is_selected = this.is_selected
        if (this.is_selected)
          this.selectedCount++
      }
    },
    async onClickSearch()
    {
      this.loadingCounter++

      this.filter.limit = ''
      let payload = this.filter

      await axios
      .post(apiRoutes["CLIENT_FINANCE_ACCOUNT_POSTED_QUICK_SEARCH"], payload, authHeader())
      .then((response) =>
      {
        if (response.data.code == 1) {
          this.docs = response.data.data
          this.selectedCount = this.docs.length
          this.is_selected = 1
        }
        else
        {
          alert('Failed');
        }

      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });
      this.loadingCounter--
    },

    async onClickPost()
    {
      this.loadingCounter++
      this.filter.limit = ''
      let payload = {docs:this.docs}

      await axios
      .post(apiRoutes["CLIENT_FINANCE_ACCOUNT_POST"], payload, authHeader())
      .then((response) =>
      {
        if (response.data.code == 1) {
          this.docs = response.data.data
        }
        else
        {
          alert('Failed');
        }
      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });
      this.loadingCounter--
    },

    async onClickUnpost()
    {
      this.loadingCounter++
      this.filter.limit = ''
      let payload = {docs:this.docs}

      await axios
      .post(apiRoutes["CLIENT_FINANCE_ACCOUNT_UNPOST"], payload, authHeader())
      .then((response) =>
      {
        if (response.data.code == 1) {
          this.docs = response.data.data
        }
        else
        {
          alert('Failed');
        }
      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });
      this.loadingCounter--
    },
  }
}
</script>
 